import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	classicLocationlessActionPromptText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	classicLocationlessActionPromptText: {
		id: 'board-location-dialogs.common.location-picker.update-url-info',
		defaultMessage:
			' This update will redirect you to a new URL for this board. Update any existing bookmarks, resources, or references to make sure they reflect this change.',
		description: 'Prompt user to update the links to their boards as the url has changed',
	},
});
export default messages;
